import { render, staticRenderFns } from "./Bronx.vue?vue&type=template&id=066132cb&scoped=true"
import script from "./Bronx.vue?vue&type=script&lang=js"
export * from "./Bronx.vue?vue&type=script&lang=js"
import style0 from "./Bronx.vue?vue&type=style&index=0&id=066132cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066132cb",
  null
  
)

export default component.exports